/**
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { actions } from '../actionTypes';

interface ISoftwareFilterState {
  halls: string;
  showDetails: boolean;
  showFavourites: boolean;
  show: string;
  searchValue: string;
}

export const initialSoftwareFilterState: ISoftwareFilterState = {
  halls: 'all',
  showDetails: false,
  showFavourites: false,
  show: 'list',
  searchValue: '',
};

interface ISoftwareFilterStates {
  initial: ISoftwareFilterState;
}

export const initialSoftwareFilterStates: ISoftwareFilterStates = {
  initial: initialSoftwareFilterState,
};

const softwareListFilters = (
  state: ISoftwareFilterStates = initialSoftwareFilterStates,
  action: any,
): ISoftwareFilterStates | undefined => {
  switch (action.type) {
    case actions.SET_SOFTWARE_FILTER: {
      const key = `${action.payload.filter.fairTag}`;
      if (state[key]) {
        state[key] = {
          ...state[key],
          ...action.payload.filter,
        };
      } else {
        state[key] = {
          ...state.initial,
          ...action.payload.filter,
        };
      }
      // "Hack", reassignment is necessary, otherwise the storage is not updatet.
      return {
        ...state,
        [key]: state[key],
      };
    }

    default: {
      return state;
    }
  }
};

export default softwareListFilters;
